var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1054_48290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9996 0H5.99985C2.70023 0 0 2.70023 0 5.99985V18.0001C0 21.2989 2.70023 24 5.99985 24H17.9996C21.2992 24 23.9994 21.2989 23.9994 18.0001V5.99985C23.9994 2.70023 21.2992 0 17.9996 0ZM21.9994 18.0001C21.9994 20.2051 20.2057 22 17.9996 22H5.99985C3.79461 22 2.00005 20.2051 2.00005 18.0001V5.99985C2.00005 3.79432 3.79461 2.00005 5.99985 2.00005H17.9996C20.2057 2.00005 21.9994 3.79432 21.9994 5.99985V18.0001Z",
    fill: "#141415"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5009 6.99968C19.3293 6.99968 20.0009 6.32813 20.0009 5.49972C20.0009 4.67131 19.3293 3.99976 18.5009 3.99976C17.6725 3.99976 17.001 4.67131 17.001 5.49972C17.001 6.32813 17.6725 6.99968 18.5009 6.99968Z",
    fill: "#141415"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 5.99976C8.68552 5.99976 6 8.68557 6 11.9996C6 15.3124 8.68552 18 11.9999 18C15.3132 18 17.9997 15.3124 17.9997 11.9996C17.9997 8.68557 15.3132 5.99976 11.9999 5.99976ZM11.9999 16C9.79098 16 8.00005 14.2091 8.00005 11.9996C8.00005 9.79015 9.79098 7.9998 11.9999 7.9998C14.2087 7.9998 15.9997 9.79015 15.9997 11.9996C15.9997 14.2091 14.2087 16 11.9999 16Z",
    fill: "#141415"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1054_48290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.f9d75a69e65e9828af163e95a0e312f4.svg";
export { ForwardRef as ReactComponent };